<main class="w-full bg-white text-black mt-[100px]">
  <section class="bg-white py-16 md:px-10 lg:px-20 mt-[80px]">
    <div class="max-w-7xl mx-auto grid lg:grid-cols-2 gap-10 items-start">
      <!-- Left Content -->
      <div class="px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        <!-- Header Section -->
        <h2
          class="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-800 mb-4 text-center sm:text-left"
        >
          Let’s Build Smarter Estates Together
        </h2>
        <p
          class="text-gray-600 text-base sm:text-lg mb-6 text-center sm:text-left"
        >
          Whether you’re a resident, developer, organization, or estate manager,
          we’re here to help you simplify operations, enhance security, and
          scale with confidence. Reach out — we’re ready to support your
          transformation.
        </p>

        <!-- CTA Buttons -->
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
          <button
            class="bg-[#336799] text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition"
          >
            Request a Demo
          </button>
          <button
            class="bg-white border border-gray-300 text-[#336799] py-3 px-6 rounded-lg hover:bg-gray-100 transition"
          >
            Chat with Sales
          </button>
          <button
            class="col-span-1 sm:col-span-2 bg-gray-800 text-white py-3 px-6 rounded-lg hover:bg-gray-900 transition"
          >
            General Inquiry
          </button>
        </div>

        <!-- Office & Contact Info -->
        <div
          class="bg-white rounded-lg py-6 shadow-sm mt-12 text-gray-700 space-y-6"
        >
          <h3 class="text-2xl font-bold text-gray-800">Reach Us Directly</h3>

          <!-- Location -->
          <div>
            <p class="font-semibold">EchobitsTech – Estate360Hub Division</p>
            <p>Abuja, Nigeria (Remote-friendly across Africa)</p>
          </div>

          <!-- Emails -->
          <div class="flex items-start gap-4 bg-indigo-50 p-4 rounded-lg">
            <div class="bg-indigo-100 p-2 rounded-full">
              <svg
                class="w-5 h-5 text-[#336799]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 12H8m8 0a4 4 0 11-8 0 4 4 0 018 0zM12 16v4m0-4h-4m4 0h4"
                />
              </svg>
            </div>
            <div class="space-y-1 text-sm break-all">
              <a
                href="mailto:support@estate360hub.com"
                class="text-indigo-700 hover:underline"
                >support@estate360hub.com</a
              ><br />
              <a
                href="mailto:info@echobitstech.com"
                class="text-indigo-700 hover:underline"
                >info@echobitstech.com</a
              >
            </div>
          </div>

          <!-- Phone Numbers -->
          <div class="flex items-start gap-4 bg-indigo-50 p-4 rounded-lg">
            <div class="bg-indigo-100 p-2 rounded-full">
              <svg
                class="w-5 h-5 text-[#336799]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 5h2l3.6 7.59-1.35 2.44a1 1 0 001.6 1.18l1.42-1.42a1 1 0 011.41 0l2.83 2.83a1 1 0 001.41 0l1.42-1.42a1 1 0 011.18 1.6l-2.44 1.35L19 19h2"
                />
              </svg>
            </div>
            <div class="text-sm">
              <p>+234 813 033 8961</p>
              <p>+234 706 590 3560</p>
            </div>
          </div>

          <!-- Social Media -->
          <div class="flex items-start gap-4 bg-indigo-50 p-4 rounded-lg">
            <div class="bg-indigo-100 p-2 rounded-full">
              <svg
                class="w-5 h-5 text-[#336799]"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M18 2h-3a1 1 0 00-1 1v3h-2V3a1 1 0 00-1-1H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V4a2 2 0 00-2-2z"
                />
              </svg>
            </div>
            <div class="flex flex-wrap gap-2 text-indigo-700 text-sm">
              <a href="#" class="hover:underline">🔗 LinkedIn</a>
              <a
                href="https://x.com/Echobitstech?t=2jsBwIfas8NE0Zck1fy4Ww&s=08"
                class="hover:underline"
                >🔗 Twitter/X</a
              >
              <a
                href="https://www.instagram.com/reel/DKzOjWyo4of/?igsh=OTh0eGlhamlvbDd3"
                class="hover:underline"
                >🔗 Instagram</a
              >
              <a
                href="https://www.facebook.com/profile.php?id=61573596525060"
                class="hover:underline"
                >🔗 Facebook</a
              >
            </div>
          </div>

          <!-- Partnership -->
          <div class="bg-white rounded-lg py-4 shadow-sm">
            <h3 class="text-xl sm:text-2xl font-bold mb-2 text-gray-800">
              Want to Partner with Us?
            </h3>
            <p class="text-gray-600 mb-4 text-sm">
              Are you a real estate developer, estate association, logistics
              company, or mortgage provider? We’re actively expanding our
              ecosystem and would love to connect.
            </p>

            <div
              class="flex items-start gap-4 bg-indigo-50 p-4 rounded-lg mb-3"
            >
              <div class="bg-indigo-100 p-2 rounded-full">
                <svg
                  class="w-5 h-5 text-[#336799]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 12H8m8 0a4 4 0 11-8 0 4 4 0 018 0zM12 16v4m0-4h-4m4 0h4"
                  />
                </svg>
              </div>
              <a
                href="mailto:partnerships@estate360hub.com"
                class="text-indigo-700 font-medium"
                >partnerships@estate360hub.com</a
              >
            </div>

            <div class="flex items-start gap-4 bg-indigo-50 p-4 rounded-lg">
              <div class="bg-indigo-100 p-2 rounded-full">
                <svg
                  class="w-5 h-5 text-[#336799]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <a href="#" class="text-indigo-700 font-medium"
                >Book a Partnership Call</a
              >
            </div>
          </div>

          <!-- Quick Access -->
          <div>
            <h3 class="text-lg sm:text-xl font-semibold text-gray-800 mb-2">
              Need Help Fast?
            </h3>
            <ul class="list-disc list-inside space-y-1 text-sm">
              <li>💬 <span>Live Chat (during business hours)</span></li>
              <li>
                📄
                <a href="#" class="text-[#336799] underline"
                  >Visit our Help Center / FAQ</a
                >
              </li>
              <li>
                📧
                <a href="#" class="text-[#336799] underline"
                  >Submit a Support Ticket</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Right Form -->
      <div class="bg-blue-50 p-8 rounded-2xl shadow-lg w-full">
        <h3 class="text-2xl font-bold text-zinc-800 mb-4">Send Us a Message</h3>
        <p class="text-zinc-600 mb-6 text-sm">
          Complete the form and we’ll get back to you within 1 business day.
        </p>

        <form class="space-y-4">
          <input
            type="text"
            placeholder="Full Name *"
            class="w-full p-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-[#336799]"
          />
          <input
            type="email"
            placeholder="Email Address *"
            class="w-full p-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-[#336799]"
          />
          <input
            type="text"
            placeholder="Phone Number (optional)"
            class="w-full p-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-[#336799]"
          />
          <input
            type="text"
            placeholder="Organization / Estate Name"
            class="w-full p-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-[#336799]"
          />
          <select
            class="w-full p-3 rounded-md border border-[] focus:ring-2 focus:ring-[#336799] text-zinc-600"
          >
            <option value="" disabled selected>Inquiry Type *</option>
            <option>Demo</option>
            <option>Support</option>
            <option>Partnership</option>
            <option>General Inquiry</option>
          </select>
          <textarea
            rows="4"
            placeholder="Your Message"
            class="w-full p-3 rounded-md border border-gray-300 focus:ring-2 focus:ring-[#336799]"
          ></textarea>

          <button
            type="submit"
            class="w-full bg-[#336799] text-white py-3 rounded-lg hover:bg-blue-700 transition font-medium"
          >
            Send Message
          </button>
        </form>

        <p class="text-xs text-gray-500 mt-4">
          By submitting this form, you agree to our
          <a href="#" class="underline text-[#336799]">Privacy Policy</a> and
          <a href="#" class="underline text-[#336799]">Terms & Conditions</a>.
        </p>
      </div>
    </div>
  </section>
</main>
